export const colors = {
  // deprecated: primary: "#2a2a72",
  // deprecated: primaryLighter: "#44449C",
  info: '#7ea9cf',
  primary: 'black',
  primaryDarker: '#1c6775',
  secondary: '#C4E648',
  black: '#1D1D1D',
  blackHovered: '#252525',
  black2: '#000000',
  black2Hovered: '#151515',
  gray: '#F2F0EC',
  grayLightest: '#f6f6f6',
  grayMedium: '#cfcfcf',
  grayDarker: '#C2C2C2',
  grayEvenDarker: '#8f8f8f',
  grayDarkest: '#555555',
  filterSectionColor: '#e1e1e1',
  white: '#FFFFFF',
  lightblue: '#E9F3F4',
  darkblue: '#023247',
  initialized: '#d59548',
  success: '#4CAF50',
  error: '#dc5273',
  turquoise: '#4A9FAC',
  listEntryEven: '#2A8E9E',
  listEntryEvenHovered: '#2A8E9EDD',
  listEntryOdd: '#09606e',
  listEntryOddHovered: '#09606eDD',
  gatewayTypeTesting: '#02324733',
  gatewayTypeFree: '#023247AA',
  disabledInput: '#023247AA',
  pickerBorderColor: '#02324766',
  monthly: '#0759a8',
  weekly: '#9976cf',
};
